<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin:0;
  padding:0;
  border:0;
}
/* body *{
/*   -webkit-filter: grayscale(100%); /* webkit */
 /*  -moz-filter: grayscale(100%); /*firefox*/
 /*  -ms-filter: grayscale(100%); /*ie9*/
 /*  -o-filter: grayscale(100%); /*opera*/
 /*  filter: grayscale(100%);
  /* filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  filter:gray; /*ie9- */
/*  } */
#app {
  font-family: 'PingFang SC','Hiragino','Sans GB','Microsoft YaHei UI','Microsoft YaHei','Source Han Sans CN','sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue